export class AddressDTO {
  public city: string;

  public cityCode: string;

  public streetWithNumber: string;
}

